// import { duplicate } from "../../http/http-calls";
import { RegexConfig } from "../RegexConfig";


// const _duplicateCheck = async (field, value, additionalData) => {
//   let fieldName =
//     field === "providerName"
//       ? "compnayname"
//       : field === "providerEmail"
//       ? "email"
//       : field === "providerPhone"
//       ? "phone"
//       : "url";

//   console.log("additionalData", additionalData);

//   let payload = {
//     [field]:
//       field === "providerPhone"
//         ? additionalData?.countryCode + "-" + value
//         : value,
//   };
//   try {
//     const res = await duplicate(fieldName, payload);
//     console.log("res", res);
//     return res.error;
//   } catch (error) {
//     console.log("error", error);
//     return error.error;
//   }
// };

export const addProviderConfig = {
  contactName: {
    required: true,
    pattern: RegexConfig.name,
    minLength: 2,
    maxLength: 25,
    errorMessage: {
      required: "*Required",
      length: "*Must be between 2 to 25 characters",
    },
  },
  providerName: {
    required: true,
    pattern: RegexConfig.name,
    minLength: 2,
    maxLength: 200,
    // checkUnique: (value) => _duplicateCheck("providerName", value),

    errorMessage: {
      required: "*Required",
      length: "*Must be between 2 to 200 characters",
    },
  },
  providerEmail: {
    required: true,
    pattern: RegexConfig.email,
    // checkUnique: (value) => _duplicateCheck("providerEmail", value),
    errorMessage: {
      required: "*Required",
      pattern: "*Please enter a valid email",
    },
  },
  providerPhone: {
    required: true,
    pattern: RegexConfig.phone,
    // checkUnique: (value, formData) =>
    //   _duplicateCheck("providerPhone", value, formData),
    errorMessage: {
      required: "*Required",
      pattern: "*Please enter a valid 10-digit phone number.",
    },
  },
  pincode: {
    required: true,
    errorMessage: {
      required: "*Required",
    },
  },
  service: {
    required: true,
    errorMessage: {
      required: "*Required",
    },
  },
  providerAddress: {
    required: true,
    minLength: 8,
    maxLength: 100,
    errorMessage: {
      required: "*Required",
      length: "*Must be between 8 to 100 characters",
    },
  },
  demographic: {
    required: false,
    // errorMessage: {
    //   required: "*Required",
    // },
  },
  providerWebsiteUrl: {
    required: false,
    pattern: RegexConfig.url,
    errorMessage: {
      pattern: "*Please enter a valid URL",
    },
  },
  isNonProfit: {
    required: false,
  },
  countryCode: {
    required: false,
  },
  isAllPincode: {
    required: false,
  },
  isChargeable: {
    required: false,
  },
  description: {
    required: false,
    minLength: 2,
    maxLength: 350,
    errorMessage: {
      required: "*Required",
      length: "*Must be between 2 to 350 characters",
    },
  },
  city: {
    required: false,
    minLength: 2,
    maxLength: 50,
    errorMessage: {
      required: "*Required",
      length: "*Must be between 2 to 50 characters",
    },
  },
  zipCode: {
    required: false,
    pattern: /^[0-9]{5}$/,
    errorMessage: {
      required: "*Required",
      pattern: "*Please enter a valid 5-digit pincode",
    },
  },
  state: {
    required: false,
    minLength: 2,
    maxLength: 50,
    errorMessage: {
      required: "*Required",
      length: "*Must be between 2 to 50 characters",
    },
  },
};
